import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import ActivityIcon from '@mui/icons-material/Assignment';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import SupervisedUserIcon from '@mui/icons-material/SupervisedUserCircle';
import WorkIcon from '@mui/icons-material/Work';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import ListIcon from '@mui/icons-material/List';
import ForumIcon from '@mui/icons-material/Forum';

import { RankingType } from '@ts-core/utils/Constants';

import { useAcademyAuthUtils } from 'modules/auth/hooks';

export default function useQuickLinks() {
  const intl = useIntl();

  const { academyHasFeature, Feature } = useAcademyAuthUtils();

  const items = useMemo(() => {
    const result = [
      {
        title: intl.formatMessage({ id: 'quickLink.assignments' }),
        icon: WorkIcon,
        to: 'assignments',
      },
    ];

    if (academyHasFeature(Feature.Activities)) {
      result.push({
        title: intl.formatMessage({ id: 'quickLink.activities' }),
        icon: ActivityIcon,
        to: `activities`,
      });
    }

    if (academyHasFeature(Feature.Ranking)) {
      result.push({
        title: intl.formatMessage({ id: 'quickLink.rankings' }),
        icon: EqualizerIcon,
        to: `rankings/${RankingType.general}`,
      });
    }

    result.push(
      {
        title: intl.formatMessage({ id: 'quickLink.attendanceControl' }),
        icon: ListIcon,
        to: `attendance/management`,
      },
      {
        title: intl.formatMessage({ id: 'quickLink.courseStats' }),
        icon: FitnessCenterIcon,
        to: 'stats',
      },
      {
        title: intl.formatMessage({ id: 'quickLink.students' }),
        icon: SupervisedUserIcon,
        to: 'students',
      }
    );

    if (academyHasFeature(Feature.VideoOnDemand)) {
      result.push({
        title: intl.formatMessage({ id: 'quickLink.mediaStats' }),
        icon: OndemandVideoIcon,
        to: 'media-stats',
      });
    }

    if (academyHasFeature(Feature.Forum)) {
      result.push({
        title: intl.formatMessage({
          id: 'quickLink.forum',
          defaultMessage: 'Foro',
        }),
        icon: ForumIcon,
        to: 'forum',
      });
    }

    return result;
  }, [intl, academyHasFeature, Feature]);

  return items;
}
